import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { NativePluginService } from '../../nativePlugin/nativePlugin.service';
import { BehaviorSubject } from 'rxjs';
import { DataStorageService } from 'src/app/storage/data-storage.service';
import { DriverTemplate } from '../driver-template';
import { VisionService } from '../vision-web/vision.service';
import { ProfileService } from 'src/app/profile/profile.service';

declare const ngDevMode: boolean;
const log = (...args: any[]) => {
  if (ngDevMode) {console.log(...args);}
};

export interface PeyeCoordinates {
  x: any;
  y: any;
}
export type WatchPeyeResultsCallback = (
  position: PeyeCoordinates | null,
  err?: any
) => void;
export type WatchPeyeResponseCallback = (
  position: string | null,
  err?: any
) => void;

@Injectable({
  providedIn: 'root',
})
export class PeyeService extends DriverTemplate {
  endTarget = 0;
  findCalibration = null;
  respPeye: string;
  flagStarted = false;
  calibrationState: string;
  lastCal: string;
  calName: string;
  lastCallbackRespTimestamp: number;
  lastCallbackCoordTimestamp = Date.now();
  lastCoordCont = 0;
  flagSetCalibration = false;
  peyeRunning = false;
  posAnterior = { x: 0, y: 0 };
  filteredX = 0;
  filteredY = 0;
  alreadyCalibrated = false;

  statusBS: BehaviorSubject<string> = new BehaviorSubject<string>(
    'initializing'
  );
  qualityBS: BehaviorSubject<string> = new BehaviorSubject<string>(
    'initializing'
  );

  profileSubscription: any;

  simulate = true;

  coordPeye: PeyeCoordinates = { x: 0, y: 0 };
  private simulationTimeInterval: NodeJS.Timeout;
  constructor(
    private plt: Platform,
    private nativePlugin: NativePluginService,
    private storage: DataStorageService,
    private vision: VisionService,
    private profile: ProfileService
  ) {
    super();
    setInterval(() => {
      this.isPeyeRunning();
    }, 10000);
    setInterval(() => {
      this.peyeQuality();
    }, 2000);

    // this.statusBS.subscribe((status) => {
    //   log('Peye status:', status); //pode avisar o usuario para desligar, ligar e reconectar
    // });

    // Use simulate mode if on browser
    if (this.plt.is('desktop') || this.plt.is('mobileweb')) {
      this.simulate = true;
    }
     this.qualityBS.subscribe((status) => {
       //log('Peye tracking quality:', status); //pode avisar o usuario para mudar posição, etc
       this.vision.peyeQuality = status;
     });
  }

  /**
   * Solicita inicialização do driver
   *
   * @returns true se o driver foi inicializado, false se o driver já estava inicializado
   */
  start() {
    //console.log('visionService enabled', this.myStatus.enabled);
    this.myStatus.enabled = true;
    if (this.myStatus.running) {
      return Promise.resolve(false);
    } else {
      if(this.simulate === true){
        this.enableSimulation();
      }
      //this.enableSimulation();
      //this.myStatus.enabled = true;
      //console.log('visionService start');
      if (this.flagStarted === false) {
        console.log('flag started peye tracker');
        this.profileSubscription = this.profile.profile$.subscribe((profile) => { //verifica mudança de perfil
          if(this.profile.profile.navSettingsBundle.bundleOptionsState.peyeCalibrationFile != undefined){
            console.log('nome da calibracao peye: ', this.profile.profile.navSettingsBundle.bundleOptionsState.peyeCalibrationFile);
            this.calName =  this.profile.profile.navSettingsBundle.bundleOptionsState.peyeCalibrationFile; //pega nome do arquivo no perfil
          }
        });
        this.connectPeye();
        this.watchPeyeResponse();
        this.watchPeyeResult();
        this.setPeyeParams();
        this.initPeye();
        //this.eyeTrackerService.startPeye();
        this.flagStarted = true; //faz com que não inicie duas vezes o peye
      }
      return  Promise.resolve(true);;
    }
  }

  /**
   * Solicita desligamento do driver
   *
   * @returns true se o driver foi desligado, false se o driver já estava desligado
   */
  stop() {
    if (this.myStatus.enabled) {
      if(this.simulate === true){
        this.disableSimulation();
      }
      console.log('peye service driver stop')
      this.disconnectPeye();
      this.flagStarted = false;
      this.profileSubscription.unsubscribe();
      this.myStatus.enabled = false;
      this.myStatus.running = false;
      this.myStatus.capturing = false;
      this.disableSimulation();
      return  Promise.resolve(true);
    } else {
      return Promise.resolve(false);
    }
  }
  /**
   * Habilita o modo de simulação
   * Injeta uma div  no dom que cobre a tela inteira e
   * captura eventos onmousemove para simular o rastreamento do olhar
   *
   */
  enableSimulation() {
    if (this.simulate) {
      // Add a red "simulation" text to the left botton of the page
      const div = document.createElement('div');
      div.id = 'eye-tracker-simulate';
      div.style.position = 'fixed';
      div.style.bottom = '0';
      div.style.left = '0';
      div.style.color = 'red';
      div.style.zIndex = '9999';
      div.style.fontSize = '2em';
      div.innerText = 'Simulation';
      document.body.appendChild(div);

      // Add event listener
      document.body.addEventListener(
        'mousemove',
        this.simulatedDataHandler,
        true
      );
      clearInterval(this.simulationTimeInterval);
      this.simulationTimeInterval = setInterval(() => {
        this.captureResultCallback({
          captureTime: performance.now(),
          coordinates: this.coordPeye,
        });
      }, 50);
    }
  }

  disableSimulation() {
    if (this.simulate) {
      // remove the red "simulation" text
      const div = document.getElementById('eye-tracker-simulate');
      if (div) {
        div.remove();
      }
      // Clear interval
      clearInterval(this.simulationTimeInterval);
      // Remove event listener
      document.body.removeEventListener(
        'mousemove',
        this.simulatedDataHandler,
        true
      );
    }
  }

  simulatedDataHandler = (event: MouseEvent) => {
    //if(Math.random() > 0.5) {
    // const windowOrigin = { x: window.scrollX, y: window.scrollY};
    // const windowSize = { x: window.innerWidth, y: window.innerHeight};
    const x = (event.clientX - window.scrollX) / window.innerWidth;
    const y = (event.clientY - window.scrollY) / window.innerHeight;
    this.coordPeye = { x, y };
    //console.log('simulate', this.coordPeye);
    //this.callback(this.coordPeye);
    //}
  };

  sendPeyeMessage(message: string) {
    //envia mensagens para o peye
    this.nativePlugin.plugin?.sendPeyeMessage({ value: message });
  }

  connectPeye() {
    //conecta com o peye
    //this.nativePlugin.plugin?.startPeyeTracker({ value: 'start service' });
    this.nativePlugin.plugin?.connectPeye({ value: 'connection' });
  }

  disconnectPeye() {
    //para encerrar conexao com o peye
    this.nativePlugin.plugin?.closePeyeConnection({ value: 'close' });
    this.peyeRunning = false;
    this.alreadyCalibrated = false;
    this.vision.peyeMode = false;
    console.log('peyeMode not running');
  }

  setPeyeParams() {
    //seta os parametros da tela para o peye
    this.sendPeyeMessage('Q;65|');
    this.sendPeyeMessage('S;230;140|');
    this.sendPeyeMessage('R;1280;800|');
    this.sendPeyeMessage('P;-114;15|');
  }

  initPeye() {
    //inicia o rastreio do peye
    this.sendPeyeMessage('F|');
    this.sendPeyeMessage('I|');
    this.sendPeyeMessage('C|');
    this.peyeRunning = true;
    this.vision.peyeMode = true;
    console.log('peyeMode running');
  }

  async watchPeyeResponse(): Promise<boolean> {
    //pega respostas gerais do Peye
    this.nativePlugin.plugin?.receivePeyeMessage(async (resp) => {
      this.lastCallbackRespTimestamp = Date.now();
      //console.log('peye running response: ', this.lastCallbackRespTimestamp);
      this.callbackResp(resp);
    });
    return true;
  }
  callbackResp(resp) {
    console.log('callback response', JSON.stringify(resp));
    this.respPeye = JSON.stringify(resp);
    if (this.respPeye.includes('c;')) {
      //encontrou arquivos de calibração
      console.log('arquivos de calibração peye tracker: ', this.respPeye);
      if(this.respPeye.includes('new_calibration')){
        this.findCalibration = this.respPeye;
        if(this.peyeRunning && this.alreadyCalibrated === false){
          this.setCalibration(this.calName); //carrega a ultima calibracao
        }
      }
      this.alreadyCalibrated = true;
    }
    if (this.respPeye.includes('b|')) {
      //finalizou calibracao de um target
      console.log('finalizou target peye tracker: ', this.respPeye);
      this.endTarget = 1;
    }
  }

  isPeyeRunning() {
    if (Date.now() - this.lastCallbackRespTimestamp > 5000) {
      //console.log('peye not running');
      this.myStatus.running = false;
      this.statusBS.next('peye not running');
    } else {
      this.myStatus.running = true;
      this.statusBS.next('peye running');
    }
  }

  //funçoes auxiliares para a calibração
  endCalibrationTarget() {
    if (this.endTarget === 1) {
      this.endTarget = 0;
      return true;
    }
  }

  findCalibrationFiles() {
    return this.findCalibration;
  }

  async getLastCalibration(name: any): Promise<boolean> {
    //salvar calibracao no perfil 
    this.profile.profile.navSettingsBundle.bundleOptionsState.peyeCalibrationFile = name;
    //await this.storage.set('lastCalibration', name).then(() => {
      this.flagSetCalibration = true;
    //});
    return this.flagSetCalibration;
  }


  setCalibration(name: string) {
    //carrega a última calibração realizada
    //this.storage.get('lastCalibration').then((lastCal) => {
      this.lastCal = name;
      console.log('peye last calibration file: ', this.lastCal);
      if(name !== null && name !== '' && name !== undefined){
        this.sendPeyeMessage(`D;${this.lastCal}|`); //carrega calibracao
        this.sendPeyeMessage('H|'); //inicia uso da calibracao acima
      }
    //});

  }

  async watchPeyeResult(): Promise<PeyeCoordinates> {
    //pega coordenadas do Peye
    this.nativePlugin.plugin?.streamingPeyeTracker((val) => {
      const data: any = val;
      //console.log('peye streaming', JSON.stringify(val));
      this.lastCallbackCoordTimestamp = Date.now();
      this.lastCoordCont++;
      const x = (data.value.x - window.scrollX) / window.innerWidth;
      const y = (data.value.y - window.scrollY) / window.innerHeight;
      //this.coordPeye = { x, y };
      this.callback({ x, y });
    });

    return this.coordPeye;
  }

  callback(pos: PeyeCoordinates) {
     console.log(
       'peye callback coord',
       JSON.stringify(pos)
     );
    // EventEmitterService.get('eye-tracker-event').emit({
    //   event: 'EYE_TRACKER_COORD',
    //   x: this.coordPeye.x,
    //   y: this.coordPeye.y,
    // });
    //console.log('peye filter atual coord', pos.x, pos.y);
    if (this.posAnterior.x === null || this.posAnterior.y === null) {
      // First time receiving coordinates, just use current position
      this.coordPeye = pos;
    }else{
      // Calculate weights based on the difference between current and previous coordinates
      const deltaX = Math.abs(pos.x - this.posAnterior.x);
      const deltaY = Math.abs(pos.y - this.posAnterior.y);
      //console.log('peye filter anterior coord', this.posAnterior.x, this.posAnterior.y);
      //console.log('peye filter delta', deltaX, deltaY, totalDelta);
      // Calculate filtered position using weighted average
      this.filteredX = ((deltaX * pos.x) + (this.posAnterior.x)) / (1+deltaX);
      this.filteredY = ((deltaY * pos.y) + (this.posAnterior.y)) / (1+deltaX);
      //console.log('peye filter coord', this.filteredX, this.filteredY);
      this.coordPeye = { x: this.filteredX, y: this.filteredY };
      this.posAnterior = pos;
    }


    this.captureResultCallback({
      captureTime: performance.now(),
      coordinates: this.coordPeye,
    });
  }

  //se por 5s nao receber dados a qualidade do rastreamento ta ruim
  //se ficar mais de 1s e menos de 5s sem receber dado a qualidade do rastreamento ta media
  //se receber os dados a qualidade do rastreamento ta boa

  peyeQuality() {
    /*if (Date.now() - this.lastCallbackCoordTimestamp > 5000) {
      this.qualityBS.next('rastreamento peye ruim');
    } else if (
      Date.now() - this.lastCallbackCoordTimestamp > 1000 &&
      Date.now() - this.lastCallbackCoordTimestamp < 5000
    ) {
      this.qualityBS.next('rastreamento peye medio');
    } else {
      this.qualityBS.next('rastreamento peye bom');
    }*/
    if(this.peyeRunning){
      if(this.lastCoordCont>15){
        this.myStatus.capturing = true;
        this.qualityBS.next('Bom');
      }else if(this.lastCoordCont>8 && this.lastCoordCont<15){
        this.myStatus.capturing = true;
        this.qualityBS.next('Médio');
      }else if(this.lastCoordCont<8){
        this.myStatus.capturing = false;
        this.qualityBS.next('Ruim');
      }

      this.lastCoordCont=0;
    }
  }


  /* getGazeCoordinates() { //funcao nao esta sendo mais usada
    if (this.plt.is('capacitor')) {
      nativePlugin.resultPeyeTracker().then((response) => {
        console.log('Response from Peye:', JSON.stringify(response));
        this.coordPeye = response.value;
        console.log(
          'Response from Peye: Coordinates: ',
          this.coordPeye.x,
          this.coordPeye.y
        );
      });

      this.watchPeyeResult();

       nativePlugin.streamingPeyeTracker().then((response) => {
         console.log('Response from Peye:', JSON.stringify(response));
         this.coordPeye = response.value;
         console.log(
           'Response from Peye: Coordinates: ',
           this.coordPeye.x,
           this.coordPeye.y
         );
       });
    } else {
      console.log('peye not available');
    }

    return this.coordPeye;
  }*/
}
